import { APPT_BOOKING_REASON_MAX, OTP_LENGTH } from "common/constants";
import { string, number } from "yup";
import * as Yup from "yup";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const apptBookReasonValidation = (required = true) => {
	let schema = string();

	if (required) {
		schema = schema.required("Please enter a reason for the appointment.");
	} else {
		schema = schema.notRequired();
	}

	schema = schema.max(APPT_BOOKING_REASON_MAX, `Please keep the appointment reason to ${APPT_BOOKING_REASON_MAX} characters or less.`);

	return schema;
};

export const apptBookPhoneValidation = (required = true) => {
	let schema = string();

	if (required) {
		schema = schema.required("Please enter the client's phone number.");
	} else {
		schema = schema.notRequired();
	}

	return schema.test("is-valid-phone", "Invalid phone number", (value) => {
		if (!value) return true;
		const phone = parsePhoneNumberFromString(value);
		return phone ? phone.isValid() : false;
	});
};

export const stringRequired = (fieldName, { min = 1, max = 1500 } = {}) => string()
	.required(`${fieldName} is required`)
	.max(max, `${fieldName} must be at most ${max} characters`)
	.min(min, `${fieldName} must be at least ${min} characters`)

export const phoneValidation = (phoneField = "phone", countryCodeField = "country_code", required = false) =>
	Yup.mixed().test("phone-validation", "Invalid phone number", function () {
		const { path, parent, createError } = this;
		const phone = parent[phoneField];
		const countryCode = parent[countryCodeField];

		if (!required && (!phone || !countryCode)) {
			return true;
		}

		// Required check
		if (required && (!phone || !countryCode)) {
			return createError({ path, message: "Phone and country code are required" });
		}

		const fullNumber = `${countryCode}${phone}`.replace(/\s+/g, "");

		const phoneNumber = parsePhoneNumberFromString(fullNumber);

		if (!phoneNumber || !phoneNumber.isValid()) {
			return createError({ path, message: "Invalid phone number" });
		}

		return true;
	});

export const otpValidation = number()
	.required("Please enter OTP")
	.test(
			"len",
			`OTP must be of ${OTP_LENGTH} digits`,
			(val) => val && val.toString().length === OTP_LENGTH
	);
